"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setENSCache = exports.useENSName = exports.getENSName = exports.setRPC = void 0;
const react_1 = require("react");
let rpc = 'https://cloudflare-eth.com/';
function setRPC(newRPC) {
    rpc = newRPC;
}
exports.setRPC = setRPC;
function getENSName(address) {
    return __awaiter(this, void 0, void 0, function* () {
        const isBrowser = typeof window !== 'undefined';
        // The namehash package is heavy, so let's lazy-load it in the browser
        // @ts-ignore
        const namehash = isBrowser ? yield Promise.resolve().then(() => __importStar(require('eth-ens-namehash'))) : require('eth-ens-namehash');
        const node = namehash.hash(`${address.substring(2)}.addr.reverse`);
        const req = yield fetch(rpc, {
            'headers': {
                'content-type': "application/json",
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'eth_call',
                id: 1,
                params: [
                    {
                        from: '0x0000000000000000000000000000000000000000',
                        data: `0x691f3431${node.substr(2)}`,
                        to: '0xa2c122be93b0074270ebee7f6b7292c7deb45047',
                    },
                    'latest',
                ],
            }),
            method: 'POST',
        });
        if (req.status !== 200) {
            throw new Error(`ENS query failed: ${req.status}`);
        }
        const response = yield req.json();
        if (!response.result) {
            throw new Error(response.error || 'ENS query failed');
        }
        const length = parseInt(response.result.substr(66, 64), 16);
        if (length === 0) {
            return null;
        }
        const nameHex = response.result.substr(130, length * 2);
        const name = Buffer.from(nameHex, 'hex').toString();
        return name;
    });
}
exports.getENSName = getENSName;
function tryGetENSName(address) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const name = yield getENSName(address);
            return name;
        }
        catch (e) {
            return null;
        }
    });
}
const cache = {};
const useENSName = (address, defaultName) => {
    const initialName = (address && cache[address.toLowerCase()]) || defaultName || null;
    const [name, setName] = (0, react_1.useState)(initialName);
    (0, react_1.useEffect)(() => {
        if (address) {
            if (name && name !== initialName) {
                setName(null);
            }
            tryGetENSName(address).then((name) => {
                cache[address.toLowerCase()] = name;
                setName(name);
            })
                .catch((e) => {
                console.warn(`Fetch name for ${address} failed: ${e.message || e.toString()}`);
            });
        }
        else {
            setName(null);
        }
    }, [address]);
    return name || defaultName || null;
};
exports.useENSName = useENSName;
const setENSCache = (address, name) => {
    cache[address.toLowerCase()] = name;
};
exports.setENSCache = setENSCache;
